// extracted by mini-css-extract-plugin
export var actions = "_b2-8";
export var arrow = "_b2-5";
export var card = "_b2-0";
export var cardWrapper = "_b2-9";
export var fieldName = "_b2-3";
export var newValue = "_b2-6";
export var oldValue = "_b2-4";
export var orangeGlowFade = "_b2-c";
export var productSection = "_b2-1";
export var scrollToBottom = "_b2-b";
export var scrollToBottomAnchor = "_b2-a";
export var scrollToBottomIcon = "_b2-d";
export var showAllButton = "_b2-7";
export var table = "_b2-2";